// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"276":"wp-swiper-bundle","346":"webpack-swiper-teasersslider","476":"webpack-menu","840":"webpack-accordions"}[chunkId] || chunkId) + ".min.js";
};